/**
 * MMP Metadata
 * This is a API for MMP Metadata
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: st116848@stud.uni-stuttgart.de.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { Execution } from '../model/execution';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class ExecutionService {

    protected basePath = 'https://localhost:8080/v1/metadata';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    /**
     * adds an execution
     * Adds an execution
     * @param run The run\&#39;s id
     * @param execution Execution item to add
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addExecution(run: string, execution?: Execution, observe?: 'body', reportProgress?: boolean): Observable<Execution>;
    public addExecution(run: string, execution?: Execution, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Execution>>;
    public addExecution(run: string, execution?: Execution, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Execution>>;
    public addExecution(run: string, execution?: Execution, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (run === null || run === undefined) {
            throw new Error('Required parameter run was null or undefined when calling addExecution.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Execution>(`${this.configuration.basePath}/experiments/runs/${encodeURIComponent(String(run))}/executions`,
            execution,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * run by id
     * Return one run by &#x60;id&#x60;
     * @param execution The execution\&#39;s id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getExecutionById(execution: string, observe?: 'body', reportProgress?: boolean): Observable<Execution>;
    public getExecutionById(execution: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Execution>>;
    public getExecutionById(execution: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Execution>>;
    public getExecutionById(execution: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (execution === null || execution === undefined) {
            throw new Error('Required parameter execution was null or undefined when calling getExecutionById.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Execution>(`${this.configuration.basePath}/experiments/runs/executions/${encodeURIComponent(String(execution))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * list of executions
     * Return list of executions
     * @param run The run\&#39;s id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getExecutionsByRun(run: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Execution>>;
    public getExecutionsByRun(run: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Execution>>>;
    public getExecutionsByRun(run: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Execution>>>;
    public getExecutionsByRun(run: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (run === null || run === undefined) {
            throw new Error('Required parameter run was null or undefined when calling getExecutionsByRun.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Execution>>(`${this.configuration.basePath}/experiments/runs/${encodeURIComponent(String(run))}/executions`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * update execution by id
     * Updates an execution
     * @param executionId The execution\&#39;s id
     * @param execution Execution item to updated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateExecutionById(executionId: string, execution?: Execution, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateExecutionById(executionId: string, execution?: Execution, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateExecutionById(executionId: string, execution?: Execution, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateExecutionById(executionId: string, execution?: Execution, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (executionId === null || executionId === undefined) {
            throw new Error('Required parameter executionId was null or undefined when calling updateExecutionById.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<any>(`${this.configuration.basePath}/experiments/runs/executions/${encodeURIComponent(String(executionId))}`,
            execution,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
